"use strict";
/**
 * FiltersJson and sub-interfaces - shared between server and client.
 * These are pure JSON shapes that describe the filters_json column.
 */
Object.defineProperty(exports, "__esModule", { value: true });
